import axios from "./axios";

export default {
    // Obtener siguiente número de envío
    getNextSendNumber() {
        const options = {
            method: 'GET',
            url: '/paymenttemplate/next-send-number',
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Obtener gastos/pagos para crear plantilla
    getExpensesForTemplate(params) {
        const options = {
            method: 'GET',
            url: '/paymenttemplate/expenses',
            headers: { 'content-type': 'application/json' },
            params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Crear una nueva plantilla de pago
    createTemplate(data) {
        const options = {
            method: 'POST',
            url: '/paymenttemplate',
            headers: { 'content-type': 'application/json' },
            data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Obtener una plantilla específica con encabezado y detalles
    getTemplateById(templateId) {
        const options = {
            method: 'GET',
            url: `/paymenttemplate/${templateId}`,
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Actualizar una plantilla existente
    updateTemplate(templateId, data) {
        const options = {
            method: 'PUT',
            url: `/paymenttemplate/${templateId}`,
            headers: { 'content-type': 'application/json' },
            data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Obtener todas las plantillas
    getAllTemplates() {
        const options = {
            method: 'GET',
            url: '/paymenttemplate',
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Obtener pagos de una plantilla específica
    getTemplatePayments(templateId) {
        const options = {
            method: 'GET',
            url: `/paymenttemplate/${templateId}/payments`,
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Obtener pagos de una plantilla con información del proveedor (para Excel)
    getTemplatePaymentsWithProvider(templateId) {
        const options = {
            method: 'GET',
            url: `/paymenttemplate/${templateId}/payments-provider`,
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    getAccountingPreview(templateId, mode = 'general') {
        const options = {
            method: 'GET',
            url: `/paymenttemplate/${templateId}/accounting-preview`,
            headers: { 'content-type': 'application/json' },
            params: { mode }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    createAccountingEntryFromTemplate(templateId, mode = 'general', payload = {}) {
        const options = {
            method: 'POST',
            url: `/paymenttemplate/${templateId}/accounting-entry`,
            headers: { 'content-type': 'application/json' },
            data: { mode, ...payload }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Eliminar una plantilla
    deleteTemplate(templateId) {
        const options = {
            method: 'DELETE',
            url: `/paymenttemplate/${templateId}`,
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Generar y descargar archivo PRN
    downloadPNRFile(templateId) {
        const options = {
            method: 'GET',
            url: `/paymenttemplate/${templateId}/pnr`,
            headers: { 'content-type': 'text/plain' },
            responseType: 'blob'  // Importante para archivos
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    // Crear un blob y descargarlo
                    const blob = new Blob([response.data], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    
                    // Obtener el nombre del archivo del header Content-Disposition
                    const contentDisposition = response.headers['content-disposition'];
                    let filename = 'archivo.prn';
                    
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                        if (filenameMatch && filenameMatch.length === 2) {
                            filename = filenameMatch[1];
                            // Asegurar que tenga extensión .prn
                            if (!filename.toLowerCase().endsWith('.prn')) {
                                filename = filename.replace(/\.(txt|TXT|pnr|PNR)$/, '.prn');
                                if (!filename.toLowerCase().endsWith('.prn')) {
                                    filename = filename + '.prn';
                                }
                            }
                        }
                    }
                    
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    
                    resolve({ success: true, filename });
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Actualizar montos parciales de una plantilla
    updatePartialAmounts(templateId, updates) {
        const options = {
            method: 'PUT',
            url: `/paymenttemplate/${templateId}/partial-amounts`,
            headers: { 'content-type': 'application/json' },
            data: { updates }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Marcar plantilla como procesada/pagada
    markAsPaid(templateId) {
        const options = {
            method: 'PUT',
            url: `/paymenttemplate/${templateId}/mark-as-paid`,
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};
